import { render } from "./VUEModificaSiti.vue?vue&type=template&id=80b33da0"
import script from "./VUEModificaSiti.vue?vue&type=script&lang=js"
export * from "./VUEModificaSiti.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__